<template>
  <div class="logout"></div>
</template>

<script>
import { jwtDecode } from 'jwt-decode';
import Config from '@/config';
import { mapGetters } from 'vuex';

export default {
  name: 'Logout',

  computed: {
    ...mapGetters({
      jwt: 'jwt',
      userInfo: 'userInfo',
    }),
  },

  created() {
    if (this.userInfo && (this.userInfo.role_id === 0 || this.userInfo.role_id === 1 || this.userInfo.role_id === 2)) {
      if (!this.jwt) {
        this.$router.push({
          name: 'Login',
        });
      }

      const decoded = jwtDecode(this.jwt);
      const exp = new Date(decoded.exp * 1000);
      setTimeout(() => {
        if (exp > new Date()) {
          // if JWT is not expired disable it by okta
          this.$store.dispatch('logout').then(() => {
            window.location.replace((Config.LOGOUT_URL += `&id_token_hint=${this.jwt}`));
          });
        } else {
          this.$store.dispatch('logout').then(() => {
            window.location.replace(Config.LOGIN_URL);
          });
        }
      }, 2000);
    } else {
      this.$store.dispatch('logout').then(() => {
        this.$router.push({ name: 'userLogin' });
      });
    }
  },
};
</script>
